import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type loadingStatus = 'loading' | 'ready' | 'error';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
  @Input() width = '73px';
  @Input() height = '73px';
}
